import React from 'react';
import styles from './FooterPricing.module.css';
import { useNavigate } from 'react-router-dom';

const FooterPricing: React.FC = () => {
    const navigate = useNavigate();
    const backNavigation = () => {
        navigate(-1);
    };
    return (
        <div className={styles.container}>
            <button className={styles.btn} onClick={backNavigation}>
                Back
            </button>
        </div>
    );
};

export default FooterPricing;
